module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$cookies.get('lang_chap') && this.$cookies.get('lang_chap').indexOf('en') !== -1) ? _c('terms-en') : _c('terms-fr')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00da3ede"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Terms.vue
// module id = 58
// module chunks = 0